import { AppSystemBroker } from "@source-digital/sd-app-broker";
import { CROSS_STORAGE_API as y } from "../sd-app-client-plugin-cross-storage/dist/index.js";
import { nanoid } from "nanoid";
var define_import_meta_env_default = { BASE_URL: "/", MODE: "production", DEV: false, PROD: true, SSR: false };
const crossStorageApiIframeUrl = define_import_meta_env_default.CROSS_STORAGE_API_IFRAME_URL ?? "https://pixel.sourcesync.io/pkg/@source-digital/sd-app-client-iframe-cross-storage@0.1.0/index.html";
const crossStoragePluginName = "uid-cross-storage";
function createCrossStorageUidPlugin() {
  return {
    name: crossStoragePluginName,
    type: "iframe",
    url: crossStorageApiIframeUrl
  };
}
function isHttps() {
  return window.location.protocol === "https:";
}
function createExperienceAppBroker(config) {
  var _a, _b, _c, _d;
  const { eeAppPlugin, eeApiPlugin, settings, logger } = config;
  if (!isHttps()) {
    if (config.disableCrossDomainUid !== true)
      logger == null ? void 0 : logger("WARN: Cross domain uid disabled because not using https");
    config.disableCrossDomainUid = true;
  }
  const clientProviderPlugins = [];
  if (config.disableCrossDomainUid !== true)
    clientProviderPlugins.push(createCrossStorageUidPlugin());
  const broker = new AppSystemBroker({
    broker: {
      scriptPluginAllowedOrigins: [
        "https://*.sourcesync.io"
      ],
      plugins: [
        {
          type: "local",
          plugin: eeApiPlugin
        },
        {
          type: "local",
          plugin: eeAppPlugin
        },
        ...((_b = (_a = settings == null ? void 0 : settings.sdAppSystem) == null ? void 0 : _a.broker) == null ? void 0 : _b.plugins) ?? []
      ]
    },
    client: {
      scriptPluginAllowedOrigins: [
        "https://*.sourcesync.io"
      ],
      providerPlugins: [
        ...clientProviderPlugins,
        ...((_d = (_c = settings == null ? void 0 : settings.sdAppSystem) == null ? void 0 : _c.client) == null ? void 0 : _d.providerPlugins) ?? []
      ]
    },
    logger
  });
  return {
    broker,
    getUid: async () => await getUid(broker, { disableCrossDomainUid: config.disableCrossDomainUid })
  };
}
const crossStoragePrefix = "_SourcePixel_";
async function getUid(broker, options = {}) {
  if (options.disableCrossDomainUid === true) {
    return nanoid();
  }
  let uid = null;
  try {
    const { api: crossStorageApi } = await broker.connectClientApi(crossStoragePluginName, y);
    uid = await crossStorageApi.cookie.get("uid", { prefix: crossStoragePrefix });
    if (uid == null) {
      uid = nanoid();
      await crossStorageApi.cookie.set("uid", uid, { prefix: crossStoragePrefix });
    }
  } catch (err) {
    console.warn("Error occurred while retrieving uid", err);
    if (uid == null) {
      uid = nanoid();
    }
  }
  return uid;
}
export {
  createExperienceAppBroker,
  getUid
};
